export const FOO = "FOO";